
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.667.333H2.333A2.15 2.15 0 00.178 2.5l-.011 13a2.16 2.16 0 002.166 2.167h17.334a2.16 2.16 0 002.166-2.167v-13A2.16 2.16 0 0019.667.333zm0 15.167H2.333V9h17.334v6.5zm0-10.833H2.333V2.5h17.334v2.167z","fill":"#fff"}})])
          )
        }
      }
    